import React, {useRef, useState} from 'react';
import {Button} from 'primereact/button';
import {useAuth} from '../../providers/auth/auth-provider';
import {useMessage} from '../../providers/message/message-provider';
import {ConnectionExportFormat, downloadConnection} from '../../shared/connection-export';

export const ConnectionExportActions = ({id, disabledReason, disabled = false}: {
  id?: number;
  disabledReason?: string;
  disabled?: boolean;
}) => {
  const {token} = useAuth();
  const {showError} = useMessage();
  const pending = useRef(new Set<ConnectionExportFormat>());
  const [loading, setLoading] = useState<ConnectionExportFormat[]>([]);
  const download = async (format: ConnectionExportFormat) => {
    if (!id || disabledReason || disabled || pending.current.has(format)) return;
    if (!token) {
      showError({message: 'Нет авторизации. Пожалуйста, войдите в аккаунт.'});
      return;
    }
    pending.current.add(format);
    setLoading(Array.from(pending.current));
    try {
      await downloadConnection(id, format, token);
    } catch (error) {
      showError({message: error instanceof Error ? error.message : 'Не удалось скачать файл. Попробуйте ещё раз.'});
    } finally {
      pending.current.delete(format);
      setLoading(Array.from(pending.current));
    }
  };
  return (
    <div className="flex flex-column gap-2" onClick={(event) => event.stopPropagation()}>
      <div className="flex flex-wrap gap-2">
        {(['pdf', 'docx'] as const).map((format) => (
          <Button key={format} type="button" outlined icon="pi pi-download"
            label={`Скачать ${format.toUpperCase()}`} aria-label={`Скачать ${format.toUpperCase()}`}
            tooltip={disabledReason ?? `Скачать ${format.toUpperCase()}`}
            disabled={!id || Boolean(disabledReason) || disabled || loading.includes(format)}
            loading={loading.includes(format)} onClick={() => download(format)} />
        ))}
      </div>
      {disabledReason ? <small className="text-color-secondary">{disabledReason}</small> : null}
    </div>
  );
};
